import { render, staticRenderFns } from "./EditDefaultImportSaleRowDescriptionTemplate.vue?vue&type=template&id=63f8bd3c&scoped=true"
import script from "./EditDefaultImportSaleRowDescriptionTemplate.vue?vue&type=script&lang=ts"
export * from "./EditDefaultImportSaleRowDescriptionTemplate.vue?vue&type=script&lang=ts"
import style0 from "./EditDefaultImportSaleRowDescriptionTemplate.vue?vue&type=style&index=0&id=63f8bd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8bd3c",
  null
  
)

export default component.exports